import WelcomePanel from './WelcomePanel';

export default WelcomePanel;
